import React, {
  Fragment,
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import {
  Table,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  Modal,
  ModalHeader,
  Form,
  ModalBody,
  Label,
  Input,
  FormFeedback,
  Spinner,
} from "reactstrap";
import moment from "moment";
import "moment-timezone";
import { Link } from "react-router-dom";
import classnames from "classnames";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import DeleteModal from "../../../Components/Common/DeleteModal";
import ApproveModal from "../../../Components/Common/ApproveModal";
import Flatpickr from "react-flatpickr";
import { isEmpty, clone } from "lodash";
import PropTypes from "prop-types";
import withRouter from "../../../Components/Common/withRouter";
import { withTranslation } from "react-i18next";
import Wave from "react-wavify";
import tankImage from "../../../assets/images/tank_CPO.png";

import {
  useTable,
  useGlobalFilter,
  useAsyncDebounce,
  useSortBy,
  useFilters,
  useExpanded,
  usePagination,
  useRowSelect,
} from "react-table";
import Select from "react-select";
import { Grid, _ } from "gridjs-react";
// Formik
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";

//Import actions
import { deleteReportTemplateDetail as onDeleteReportTemplateDetail } from "../../../store/reportTemplateDetail/action";
import {
  getReportTemplate as onGetReportTemplates,
  addNewReportTemplate as onAddNewReportTemplate,
  updateReportTemplate as onUpdateReportTemplate,
  deleteReportTemplate as onDeleteReportTemplate,
  getReportTemplateLoading,
} from "../../../store/reportTemplate/action";
import { getClient, resetClientState } from "../../../store/client/action";
import { getCompany, resetCompanyState } from "../../../store/company/action";
import {
  getDeviceOne as onGetDevicesOne,
  getDevice,
  resetDeviceState,
} from "../../../store/device/action";
import { getHistory, resetHistoryState } from "../../../store/history/action";
import { getSensor, resetSensorState } from "../../../store/sensor/action";
import { getUser, resetUserState } from "../../../store/user/action";
import {
  getParameter,
  resetParameterState,
} from "../../../store/parameter/action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import socketIO from "../../../helpers/socket";
import StatisticComponent from "../../../Components/Common/StatisticComponent";

const io = socketIO.getInstance();
io.setHost("https://socket.atapteknologi.id");
const socket = io.getSocket();

const ReportTemplate = (props) => {
  const { t } = props;
  const [isConnected, setIsConnected] = useState(socket.connected);
  const [modal, setModal] = useState(false);
  const [modalDetail, setModalDetail] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const dispatch = useDispatch();
  const [series, setSeries] = useState([]);
  const [seriesCategories, setSeriesCategories] = useState([]);
  const [labels, setLabels] = useState([]);

  const {
    reportTemplates,
    loading,
    clients,
    devices,
    parameters,
    sensors,
    companies,
    companiesLoading,
    users,
    userLoading,
    deviceOnes,
    histories,
  } = useSelector((state) => ({
    reportTemplates: state.ReportTemplate.reportTemplates,
    isReportTemplateCreated: state.ReportTemplate.isReportTemplateCreated,
    isReportTemplateSuccess: state.ReportTemplate.isReportTemplateSuccess,
    loading: state.ReportTemplate.loading,
    error: state.ReportTemplate.error,
    reportTemplateDetails: state.ReportTemplateDetail.reportTemplateDetails,
    reportTemplateDetailLoading: state.ReportTemplateDetail.loading,
    isReportTemplateDetailCreated:
      state.ReportTemplateDetail.isReportTemplateDetailCreated,
    isReportTemplateDetailSuccess:
      state.ReportTemplateDetail.isReportTemplateDetailSuccess,
    clients: state.Client.clients,
    devices: state.Device.devices,
    parameters: state.Parameter.parameters,
    sensors: state.Sensor.sensors,
    companies: state.Company.companies,
    companiesLoading: state.Company.loading,
    users: state.User.users,
    userLoading: state.User.loading,
    deviceOnes: state.Device.deviceOnes,
    histories: state.History.histories,
  }));

  const [isSearch, setIsSearch] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [uidEvents, setUidEvents] = useState([]);
  const [reportTemplateList, setReportTemplateList] = useState([]);
  const [reportTemplate, setReportTemplate] = useState([]);
  const [taskDetailAddedId, setReportTemplateDetailAddedId] = useState(0);
  const [info, setInfo] = useState([]);
  const [isExportCSV, setIsExportCSV] = useState(false);
  const [statusActive, setStatusActive] = useState([]);
  const [reportTemplateDetail, setReportTemplateDetail] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [approveModal, setApproveModal] = useState(false);
  const [positionList, setPositionList] = useState([]);
  const [roles, setRoles] = useState(null);
  const [userType, setUserType] = useState("user");
  const [unitName, setUnitName] = useState({});
  const [templateId, setTemplateId] = useState();
  const [clientList, setClientList] = useState([]);
  const [companyList, setCompanyList] = useState([]);
  const [companyId, setCompanyId] = useState();
  const [clientName, setClientName] = useState("");
  const [deviceList, setDeviceList] = useState([]);
  const [parameterList, setParameterList] = useState([]);
  const [parameterSelects, setParameterSelects] = useState([]);
  const [sensorList, setSensorList] = useState([]);
  const [sensorId, setSensorId] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [isDetailClick, setIsDetailClick] = useState(false);
  const [inputVal, setInputVal] = useState();
  const toggleDropdown = () => setDropdownOpen((prevState) => !prevState);
  const [outerText, setOuterText] = useState();
  const [detailArr, setDetailArr] = useState([]);
  const [deleteParameterId, setDeleteParameterId] = useState(-1);
  const [deleteParameterIndex, setDeleteParameterIndex] = useState(-1);
  const [searchValueSecond, setSearchValueSecond] = useState([]);
  const [mailToList, setMailToList] = useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [isEditDetail, setIsEditDetail] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [deleteModalDetail, setDeleteModalDetail] = useState(false);
  const [deleteModalMulti, setDeleteModalMulti] = useState(false);
  const [templateValue, setTemplateValue] = useState();
  const [periodDate, setPeriodDate] = useState();
  const [clientId, setClientId] = useState();
  const [templateDetail, setTemplateDetail] = useState([]);
  const [paramLabel, setParamLabel] = useState([]);
  const [sensorSelect, setSensorSelect] = useState({
    label: "",
    value: "",
    deviceId: "",
  });
  const [deviceId, setDeviceId] = useState(-1);

  const visible = [
    {
      options: [
        { label: "All Visible Record", value: 1 },
        { label: "All Record", value: 2 },
      ],
    },
  ];
  const ref = useRef(null);

  const statusActiveData = [
    {
      options: [
        { label: "Draft", value: 1 },
        { label: "Activated", value: 2 },
        { label: "Deactivated", value: 3 },
      ],
    },
  ];

  const defaultdate = () => {
    return moment(new Date())
      .tz("Asia/Jakarta")
      .format("YYYY/MM/DD HH:mm:ss")
      .toString();
  };

  const template = [
    {
      options: [
        { label: "Daily", value: "daily" },
        { label: "Weekly", value: "weekly" },
        { label: "Monthly", value: "monthly" },
        { label: "Period", value: "period" },
      ],
    },
  ];

  const onClickDelete = (reportTemplate) => {
    setReportTemplate(reportTemplate);
    setDeleteModal(true);
  };

  const onClickDeleteDetail = (reportTemplateDetail) => {
    setReportTemplateDetail(reportTemplateDetail);
    setDeleteModalDetail(true);
  };

  const handleDeleteReportTemplate = () => {
    if (reportTemplate) {
      dispatch(onDeleteReportTemplate(reportTemplate));
      setDeleteModal(false);
    }
  };

  const handleDeleteReportTemplateDetail = () => {
    if (reportTemplateDetail) {
      setReportTemplateDetailAddedId(reportTemplateDetail.reportTemplateId);
      dispatch(onDeleteReportTemplateDetail(reportTemplateDetail));
      setDeleteModalDetail(false);
    }
  };

  const onClickApprove = (user) => {
    setReportTemplate(user);
    setApproveModal(true);
  };

  useEffect(() => {
    setIsLoading(loading);
  }, [loading]);

  const toggleTab = (tab, type) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
      let filteredReportTemplates = reportTemplates;
      if (type !== "all") {
        filteredReportTemplates = reportTemplates.filter(
          (reportTemplate) => reportTemplate.rptTemplate_status.name === type
        );
      }
      setReportTemplateList(filteredReportTemplates);
    }
  };

  useEffect(() => {
    if (!isSearch) {
      dispatch(resetClientState());
      dispatch(getClient({ status: 2 }));
      dispatch(resetSensorState());
      dispatch(getSensor({ status: 2 }));
      setIsSearch(true);
      const obj = JSON.parse(sessionStorage.getItem("authUser"));
      if (obj) {
        dispatch(resetUserState());
        dispatch(
          getUser({
            type: "Task",
            clientId: obj.data.clientId,
          })
        );
        if (obj.data && obj.data.userType) setUserType(obj.data.userType);
        if (obj.data.user_client && obj.data.user_client.id) {
          setClientName(obj.data.user_client.id);
        }
        if (obj.data.userType === "company") {
          setCompanyId(obj.data.companyId);
          setClientId(obj.data.clientId);
        } else if (obj.data.userType === "client") {
          setClientId(obj.data.clientId);
        }
      } else {
        window.location = "/logout";
      }
    }
  }, [dispatch, reportTemplates, isSearch, clientId]);

  useEffect(() => {
    var data = [];
    var opt = [];
    users.forEach((item, key) => {
      const name = item.name;
      const id = item.id;
      const taskListId = item.taskListId;
      const clientId = item.clientId;
      const position =
        item.user_position && item.user_position.name
          ? `, ${item.user_position.name}`
          : "";
      const client_name =
        item.user_client && item.user_client.name
          ? item.user_client.name
          : "Not set";
      var obj = {
        label: name + position + " - " + client_name,
        value: id,
        taskListId: taskListId,
        clientId: clientId,
      };
      opt.push(obj);
    });
    var option = { options: opt };
    data.push(option);

    if (users.length > 0) {
      setMailToList(data);
    }
  }, [users]);

  useEffect(() => {
    if (userType === "company" && companyId) {
      dispatch(resetDeviceState());
      dispatch(getDevice({ companyId: companyId, status: 2 }));
    }
  }, [userType, dispatch, companyId]);

  useEffect(() => {
    dispatch(resetParameterState());
    dispatch(getParameter({ status: 2 }));
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(reportTemplates)) {
      setIsEdit(false);
      setReportTemplateList(reportTemplates);
      let current = 0;
      if (taskDetailAddedId !== 0) {
        reportTemplates.forEach((obj, i) => {
          if (obj.id === taskDetailAddedId) current = i;
        });
      }
      setInfo(reportTemplates[current]);
    }
  }, [reportTemplates, taskDetailAddedId]);

  useEffect(() => {
    if (parameters) {
      let dataLabel = [];
      for (const data of parameters) {
        if (
          data.value !== "longitude" &&
          data.value !== "latitude" &&
          data.value !== "device_time"
        ) {
          dataLabel.push({ label: data.label, value: data.value });
        }
      }
      setLabels(dataLabel);
    }
  }, [parameters]);

  useEffect(() => {
    if (deviceOnes) {
      dispatch(resetHistoryState());
      dispatch(
        getHistory({
          type: "daily",
          uid: deviceOnes.uid ? deviceOnes.uid : "[]",
        })
      );
    }
  }, [deviceOnes, dispatch]);

  useEffect(() => {
    if (histories && isDone) {
      const start = moment().startOf(histories[0]?.datetime);
      const times = histories.length;

      let arrCat = [];
      for (let i = 0; i < times; i++) {
        const toPrint = moment(start)
          .add(60 * i, "minutes")
          .format("YYYY-MM-DD HH:mm");

        arrCat.push(toPrint);
      }
      setSeriesCategories(arrCat);
    }
  }, [histories, isDone]);

  useEffect(() => {
    if (histories && labels && isDone) {
      if (isDone) {
        let data = [];
        labels.forEach((z) => {
          let obj = {};
          obj.name = z.label;
          let arr = [];
          let entries;
          histories.forEach((item) => {
            let parseData = JSON.parse(item.data);
            entries = Object.entries(parseData);
            entries.forEach((e) => {
              if (e[0] === z.value) {
                if (e[0] !== "latitude" && e[0] !== "longitude") {
                  arr.push(Math.round(e[1]));
                }
              }
            });
          });
          obj.data = arr;
          data.push(obj);
        });
        setSeries(data);
      }
    }
  }, [histories, labels, parameters, isDone]);

  useEffect(() => {
    if (!isEmpty(devices)) {
      var data = [];
      var opt = [];
      devices.forEach((item, key) => {
        console.log(item);
        const name = item.device_branch.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setDeviceList(data);
    }
  }, [devices]);

  useEffect(() => {
    if (!isEmpty(parameters)) {
      var data = [];
      var opt = [];
      parameters.forEach((item, key) => {
        const name = item.label;
        const id = item.id;
        var obj = { label: name, value: id, sensorId: item.sensorId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setParameterList(data);
    }
  }, [parameters]);

  useEffect(() => {
    if (!isEmpty(sensors)) {
      var data = [];
      var opt = [];
      sensors.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id, deviceId: item.deviceId };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setSensorList(data);
    }
  }, [sensors]);

  useEffect(() => {
    if (!isEmpty(companies)) {
      var data = [];
      var opt = [];
      companies.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setCompanyList(data);
    }
  }, [companies]);

  useEffect(() => {
    if (!isEmpty(clients)) {
      var data = [];
      var opt = [];
      clients.forEach((item, key) => {
        const name = item.name;
        const id = item.id;
        var obj = { label: name, value: id };
        opt.push(obj);
      });
      var option = { options: opt };
      data.push(option);
      setClientList(data);
    }
  }, [clients]);

  useEffect(() => {
    function onConnect() {
      setIsConnected(true);
    }

    function onDisconnect() {
      setIsConnected(false);
    }

    socket.on("connect", onConnect);
    socket.on("disconnect", onDisconnect);

    return () => {
      socket.off("connect", onConnect);
      socket.off("disconnect", onDisconnect);
    };
  });

  const onUidEvent = useCallback(
    (value) => {
      const val = JSON.parse(value);
      const data = uidEvents.filter((item) => item.uid !== val.uid);
      data.push(val);
      setUidEvents(data);
    },
    [uidEvents]
  );

  useEffect(() => {
    socket.on(deviceOnes && deviceOnes ? deviceOnes.uid : "", onUidEvent);

    return () => {
      socket.off(deviceOnes && deviceOnes ? deviceOnes.uid : "", onUidEvent);
    };
  }, [uidEvents, deviceOnes, onUidEvent]);

  // useEffect(() => {
  //   console.log("histories", histories);
  //   if (histories.length > 0) {
  //     histories.forEach((element) => {
  //       if (deviceOnes.uid === element.uid) {
  //         deviceOnes.device_parameter &&
  //           deviceOnes.device_parameter.forEach((parameter, parameterIndex) => {
  //             if (element.message) {
  //               const amount = element.message[parameter.value];
  //               if (element.device_time) {
  //                 element.message.datetime = handleValidDate(
  //                   element.device_time
  //                 );
  //                 element.message.device_time = handleValidDate(
  //                   element.device_time
  //                 );
  //               }
  //               if (amount) {
  //                 deviceOnes.device_parameter[parameterIndex].amount = amount;
  //               }
  //               // else if (amount === 0) {
  //               //   devices[deviceIndex].device_parameter[
  //               //     parameterIndex
  //               //   ].amount = "0";
  //               // }
  //             }
  //           });
  //       }
  //     });
  //   }
  //   setIsDone(true);
  // }, [histories, deviceOnes]);

  useEffect(() => {
    uidEvents.forEach((element) => {
      if (deviceOnes.uid === element.uid) {
        deviceOnes.device_parameter &&
          deviceOnes.device_parameter.forEach((parameter, parameterIndex) => {
            if (element.message) {
              const amount = element.message[parameter.value];
              if (
                parameter.value === "device_time" &&
                element.message.device_time
              ) {
                var date1 = new Date(parameter.amount);
                var date2 = new Date(element.device_time);
                if (date1.getTime() > date2.getTime()) {
                  element.message.device_time = handleValidDate(
                    parameter.amount
                  );
                } else {
                  element.message.device_time = handleValidDate(
                    element.device_time
                  );
                }
              }
              if (parameter.value === "datetime" && element.message.datetime) {
                var date3 = new Date(parameter.amount);
                var date4 = new Date(element.device_time);
                if (date3.getTime() > date4.getTime()) {
                  element.message.datetime = handleValidDate(parameter.amount);
                } else {
                  element.message.datetime = handleValidDate(
                    element.device_time
                  );
                }
              }
              if (amount) {
                deviceOnes.device_parameter[parameterIndex].amount = amount;
              }
              //  else if (amount === 0) {
              //   devices[deviceIndex].device_parameter[
              //     parameterIndex
              //   ].amount = "0";
              // }
            }
          });
      }
    });
    console.log(uidEvents, "- Has Changed");
  }, [uidEvents, isDone, deviceOnes]);

  useEffect(() => {
    if (uidEvents.length) {
      dispatch(
        getParameter({
          sensor: deviceOnes.device_sensor[0] && deviceOnes.device_sensor[0].id,
          status: 2,
        })
      );
    }
  }, [uidEvents, deviceOnes, dispatch]);

  const [filterDate, setFilterDate] = useState(defaultdate());
  const [sendMailDate, setSendMailDate] = useState();

  const handleValidDate = (date) => {
    return moment(new Date(date), "YYYY/MM/DD")
      .tz("Asia/Jakarta")
      .format("MMM D, YYYY");
  };

  const toggle = useCallback(() => {
    if (modal) {
      setModal(false);
      setReportTemplate(null);
      setTemplateDetail([]);
      setIsDetailClick(false);
    } else {
      setModal(true);
    }
  }, [modal]);

  const handleReportTemplateClick = useCallback(
    (arg) => {
      const data = arg;
      setDeviceId(data.deviceId);
      sensorList[0].options.forEach((sensor) => {
        if (
          sensor.value === data.sensorId &&
          sensor.deviceId === data.deviceId
        ) {
          setSensorId(sensor.value);
          setSensorSelect({
            label: sensor.label,
            value: sensor.value,
            deviceId: sensor.deviceId,
          });
          return;
        }
      });
      let nama = data.type;
      let besar = nama.charAt(0).toUpperCase();
      let kecil = nama.slice(1);
      let fc = [];
      let fe = [];
      let detailSelect = [];
      data.rptTemplate_detail.forEach((item) => {
        detailSelect.push(item.parameterId);
        fc.push({
          name: item.name,
          parameterId: item.parameterId,
        });
        fe.push({
          paramLabel: item.rptTemplateDetail_parameter.label,
        });
      });
      if (data.rptTemplate_detail) {
        setIsDetailClick(true);
      }
      setTemplateDetail(fc);
      setParameterSelects(detailSelect);
      setReportTemplate({
        id: data.id,
        name: data.name,
        client: {
          label: data.rptTemplate_client.name,
          value: data.rptTemplate_client.id,
        },
        company: {
          label: data.rptTemplate_company.name,
          value: data.rptTemplate_company.id,
        },
        device: {
          label: data.rptTemplate_device.name,
          value: data.rptTemplate_device.id,
        },
        description: data.description,
        status: {
          label: data.rptTemplate_status.name,
          value: data.rptTemplate_status.id,
        },
        type: {
          label: besar + kecil,
          value: data.type,
        },
        templateDetail: fc,
        paramLabel: fe,
      });

      setIsEdit(true);
      toggle();
    },
    [toggle, sensorList]
  );

  const getSensorSelectList = useMemo(() => {
    if (deviceId > -1) {
      const newOptSensor =
        sensorList[0] &&
        sensorList[0].options.filter((itm) => {
          return itm.deviceId === deviceId;
        });
      return [{ options: newOptSensor }];
    } // else {
    //   return sensorList;
    // }
  }, [sensorList, deviceId]);

  const toggleDetail = useCallback(() => {
    if (modalDetail) {
      setModalDetail(false);
      setReportTemplateDetail(null);
      setReportTemplate(null);
    } else {
      setModalDetail(true);
    }
  }, [modalDetail]);

  const columns = useMemo(
    () => [
      {
        Header: (
          <input
            type='checkbox'
            id='checkBoxAllTask'
            className='form-check-input'
            onClick={() => checkedAllReportTemplate()}
          />
        ),
        Cell: (cellProps) => {
          return (
            <input
              type='checkbox'
              className='dataCheckboxTask form-check-input'
              value={cellProps.row.original.id}
            />
          );
        },
        id: "#",
      },
      {
        Header: " ",
        maxWidth: 100,
        filterable: false,
        Cell: (cellProps) => {
          return (
            <div className='hstack gap-2 mt-4 mt-sm-0'>
              <Link
                to='#'
                className='btn-icon btn btn-sm btn-soft-primary'
                onClick={() => {
                  setInfo(cellProps.row.original);
                  setDetailArr(cellProps.row.original.rptTemplate_detail);
                  ref.current?.scrollIntoView({ behavior: "smooth" });
                  setTemplateId(cellProps.row.original.id);
                }}>
                <i className='ri-eye-line fs-15'></i>
              </Link>
              <Link
                to='#'
                className='btn-icon btn btn-sm btn-soft-primary edit-item-btn'
                onClick={() => {
                  handleReportTemplateClick(cellProps.row.original);
                }}>
                <i className='ri-pencil-line fs-16'></i>
              </Link>
              <Link
                to='#'
                className='btn-icon btn btn-sm btn-soft-danger remove-item-btn'
                onClick={() => {
                  const reportTemplateData = cellProps.row.original;
                  onClickDelete(reportTemplateData);
                }}>
                <i className=' ri-delete-bin-line fs-15'></i>
              </Link>
            </div>
          );
        },
      },
      {
        Header: `${t("Name")}`,
        accessor: "name",
        filterable: true,
      },
      {
        Header: `${t("Type")}`,
        accessor: "type",
        filterable: true,
      },
      {
        Header: `${t("Device")}`,
        accessor: "rptTemplate_device.name",
        filterable: true,
      },
      {
        Header: `${t("Description")}`,
        accessor: "description",
        filterable: true,
      },
      {
        Header: `${t("Status")}`,
        accessor: "rptTemplate_status.name",
        filterable: true,
        Cell: (cell) => {
          switch (cell.value) {
            case "Activated":
              return (
                <span className='badge text-uppercase badge-soft-secondary'>
                  {t(cell.value)}
                </span>
              );
            case "Deactivated":
              return (
                <span className='badge text-uppercase badge-soft-danger'>
                  {t(cell.value)}
                </span>
              );
            case "Draft":
              return (
                <span className='badge text-uppercase badge-soft-warning'>
                  {t(cell.value)}
                </span>
              );
            default:
              return (
                <span className='badge text-uppercase badge-soft-warning'>
                  {t(cell.value)}
                </span>
              );
          }
        },
      },
    ],
    [handleReportTemplateClick, t]
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    canPreviousPage,
    canNextPage,
    pageOptions,
    gotoPage,
    nextPage,
    previousPage,
    setPageSize,
    preGlobalFilteredRows,
    setGlobalFilter,
    state: { pageIndex, pageSize },
  } = useTable(
    {
      columns: columns,
      data: reportTemplateList,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const columnsSecond = useMemo(
    () => [
      {
        Header: `${t("Name")}`,
        accessor: "name",
        filterable: true,
      },
      {
        Header: `${t("Parameter")}`,
        accessor: "rptTemplateDetail_parameter.label",
        filterable: true,
      },
    ],
    [t]
  );

  const {
    getTableProps: getTablePropsSecond,
    getTableBodyProps: getTableBodyPropsSecond,
    headerGroups: headerGroupsSecond,
    page: pageSecond,
    prepareRow: prepareRowSecond,
    canPreviousPage: canPreviousPageSecond,
    canNextPage: canNextPageSecond,
    pageOptions: pageOptionsSecond,
    gotoPage: gotoPageSecond,
    nextPage: nextPageSecond,
    previousPage: previousPageSecond,
    setPageSize: setPageSizeSecond,
    preGlobalFilteredRows: preGlobalFilteredRowsSecond,
    setGlobalFilter: setGlobalFilterSecond,
    state: { pageIndex: pageIndexSecond, pageSize: pageSizeSecond },
  } = useTable(
    {
      columns: columnsSecond,
      data: detailArr,
      defaultColumn: { Filter: null },
      initialState: {
        pageIndex: 0,
        pageSize: 8,
        selectedRowIds: 0,
        sortBy: [
          {
            desc: true,
          },
        ],
      },
    },
    useGlobalFilter,
    useFilters,
    useSortBy,
    useExpanded,
    usePagination,
    useRowSelect
  );

  const onChangeSecond = useAsyncDebounce((value) => {
    setGlobalFilterSecond(value || undefined);
  }, 200);

  const generateSortingIndicator = (column) => {
    return column.isSorted ? (column.isSortedDesc ? " " : "") : "";
  };

  const generateFilterable = (column) => {
    return column.filterable
      ? column.isSorted
        ? column.isSortedDesc
          ? " sorting_desc"
          : " sorting_asc"
        : " sort"
      : "";
  };

  const onChangeInSelect = (event) => {
    setPageSize(Number(event.target.value));
  };

  const onChangeInInput = (event) => {
    const page = event.target.value ? Number(event.target.value) - 1 : 0;
    gotoPage(page);
  };

  const count = preGlobalFilteredRows.length;
  const [searchValue, setSearchValue] = useState([]);
  const onChange = useAsyncDebounce((value) => {
    setGlobalFilter(value || undefined);
  }, 200);

  const handleApproveReportTemplate = () => {
    if (reportTemplate) {
      reportTemplate.setApprove = true;
      dispatch(onUpdateReportTemplate(reportTemplate));
      setApproveModal(false);
    }
  };

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      client: (reportTemplate && reportTemplate.client) || "",
      device: (reportTemplate && reportTemplate.device) || "",
      type: (reportTemplate && reportTemplate.type) || "",
      period: (reportTemplate && reportTemplate.period) || "",
      name: (reportTemplate && reportTemplate.name) || "",
      description: (reportTemplate && reportTemplate.description) || "",
      status: (reportTemplate && reportTemplate.status) || "",
      templateDetail: (reportTemplate && reportTemplate.templateDetail) || "",
      sensor: sensorSelect,
      paramLabel: (reportTemplate && reportTemplate.paramLabel) || "",
      company: (reportTemplate && reportTemplate.company) || "",
      mailto: reportTemplate && reportTemplate.mailto,
      sendMail: (reportTemplate && reportTemplate.sendMail) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name").nullable(true),
    }),
    onSubmit: (values) => {
      dispatch(getReportTemplateLoading());
      if (isEdit) {
        const updateReportTemplate = {
          id: reportTemplate ? reportTemplate.id : 0,
          clientId: clientId ? clientId : values.client.value,
          companyId: companyId ? companyId : values.company.value,
          deviceId: values.device.value,
          type: values.type.value,
          name: values.name,
          description: values.description,
          statusId: values.status.value,
          period: periodDate ? periodDate : "",
          templateDetail: JSON.stringify(templateDetail),
          sensorId: values.sensor.value,
          mailto: values.mailto,
          sendMail: sendMailDate,
        };
        dispatch(onUpdateReportTemplate(updateReportTemplate));
        validation.resetForm();
      } else {
        const newReportTemplate = {
          clientId: clientId ? clientId : values.client.value,
          companyId: companyId ? companyId : values.company.value,
          deviceId: values.device.value,
          type: values.type.value,
          name: values.name,
          description: values.description,
          statusId: values.status.value,
          period: periodDate ? periodDate : "",
          templateDetail: JSON.stringify(templateDetail),
          sensorId: values.sensor.value,
          mailto: values.mailto,
          sendMail: sendMailDate,
        };
        console.log(newReportTemplate);
        // dispatch(onAddNewReportTemplate(newReportTemplate));
        validation.resetForm();
      }
      toggle();
    },
  });

  const checkedAllReportTemplate = () => {
    const checkall = document.getElementById("checkBoxAllTask");
    const ele = document.querySelectorAll(".dataCheckboxTask");

    if (checkall.checked) {
      ele.forEach((ele) => {
        ele.checked = true;
      });
    } else {
      ele.forEach((ele) => {
        ele.checked = false;
      });
    }
  };

  // Delete Multiple
  const deleteMultiple = () => {
    const ele = document.querySelectorAll(".dataCheckboxTask:checked");
    const checkall = document.getElementById("checkBoxAllTask");
    ele.forEach((element) => {
      dispatch(onDeleteReportTemplate(element.value));
    });
    checkall.checked = false;
  };

  function handleFilter() {
    let startat = "";
    let endat = "";
    let datearr = filterDate.split(" to ");
    if (datearr[1]) {
      startat = datearr[0];
      endat = datearr[1];
    }
    var status = statusActive.value ? statusActive.value : "";
    const param = {
      title: searchValue,
      startat: startat,
      endat: endat,
      status: status,
    };
    dispatch(onGetReportTemplates(param));
  }

  const handleCompany = (data) => {
    dispatch(resetCompanyState());
    dispatch(getCompany({ clientId: data.value }));
  };

  const handleDevice = (data) => {
    dispatch(resetDeviceState());
    dispatch(getDevice({ companyId: data.value }));
  };

  function handleDetailAdd() {
    let fc = [];
    let fe = [];
    if (templateDetail && templateDetail) {
      templateDetail.forEach((element) => {
        fc.push(element);
      });
    }
    if (paramLabel && paramLabel) {
      paramLabel.forEach((element) => {
        fe.push(element);
      });
    }
    fc.push({
      name: "",
      parameterId: "",
    });
    fe.push({
      paramLabel: "",
    });
    setTemplateDetail(fc);
    setParamLabel(fe);
  }

  const getParameterValue = useCallback(
    (id) => {
      if (id > -1 && sensorId > -1) {
        const val = parameterList[0].options.filter((itm) => {
          return itm.value === id && itm.sensorId === sensorId;
        });
        return val;
      }
    },
    [parameterList, sensorId]
  );

  const getParameterOptions = useMemo(() => {
    if (sensorId > -1) {
      const val = parameterList[0].options.filter((itm) => {
        return (
          itm.sensorId === sensorId &&
          parameterSelects.indexOf(itm.value) === -1
        );
      });

      return val;
    }
  }, [parameterList, parameterSelects, sensorId]);

  const handleDeleteParameters = (id, idx) => {
    if (id > -1) {
      const fc = parameterSelects.filter((itm) => {
        return id !== itm;
      });
      setParameterSelects(fc);
      const td = templateDetail.filter((itm, i) => {
        return i !== idx;
      });
      setTemplateDetail(td);
    }
  };

  const handleParams = (params) => {
    console.log(params);
    if (typeof params === "number") {
      return params.toFixed(2);
    } else {
      return params;
    }
  };

  document.title = `${t("Report")} | TELKOMSEL - IOT Monitoring`;

  return (
    <div className='page-content'>
      <ApproveModal
        data={reportTemplate && reportTemplate.task_name}
        show={approveModal}
        onApproveClick={handleApproveReportTemplate}
        onCloseClick={() => setApproveModal(false)}
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteReportTemplate}
        onCloseClick={() => setDeleteModal(false)}
      />
      <DeleteModal
        show={deleteModalDetail}
        onDeleteClick={handleDeleteReportTemplateDetail}
        onCloseClick={() => setDeleteModalDetail(false)}
      />
      <DeleteModal
        show={deleteModalMulti}
        onDeleteClick={() => {
          deleteMultiple();
          setDeleteModalMulti(false);
        }}
        onCloseClick={() => setDeleteModalMulti(false)}
      />
      <Container fluid>
        <Row>
          <Col xxl={12}>
            <Card style={{ height: "550px" }}>
              <CardBody className='pt-0'>
                <div>
                  <Row className='mb-3'>
                    <CardBody>
                      <form>
                        <Row>
                          <Col sm={6} className='col-xxl-2'>
                            <div className='search-box me-2 mb-2 col-12'>
                              <Flatpickr
                                className='form-control'
                                id='datepicker-publish-input'
                                placeholder={t("Select created date")}
                                options={{
                                  mode: "range",
                                  dateFormat: "Y/m/d",
                                }}
                                onChange={(obj, str) => {
                                  setFilterDate(str);
                                }}
                              />
                              <i className='bx bx-calendar-alt search-icon'></i>
                            </div>
                          </Col>
                          <Col sm={4} className='col-xxl-2'>
                            <div className='me-2 mb-2 col-12'>
                              <Select
                                placeholder={t("Select Device")}
                                onChange={(e) => {
                                  console.log(e);
                                  dispatch(onGetDevicesOne(e.value));
                                }}
                                options={deviceList}
                                name='choices-single-default'
                                id='idStatus'></Select>
                            </div>
                          </Col>
                          <Col className='col-xxl-2'>
                            <div>
                              <button
                                type='button'
                                className='btn btn-light w-100'
                                onClick={(e) => {
                                  e.preventDefault();
                                  handleFilter();
                                }}>
                                <i className='ri-search-line me-1 align-bottom fs-14'></i>{" "}
                                {t("Search")}
                              </button>
                            </div>
                          </Col>
                        </Row>
                      </form>
                      <Row className='mt-5'>
                        <Col
                          lg={6}
                          className='border border-2 '
                          style={{ height: "420px" }}>
                          <Row className='mb-5'>
                            <h5 className='mt-3'>
                              {deviceOnes.device_branch
                                ? deviceOnes.device_branch.name
                                : "-"}
                            </h5>
                            <Col lg={6}>
                              <Wave
                                fill='#538ed7'
                                paused={false}
                                style={{
                                  display: "flex",
                                  position: "relative",
                                  top: 0,
                                  left: 0,
                                  marginLeft: "30%",
                                  marginTop: "60px",
                                  width: "48%",
                                  height: "267px",
                                }}
                                options={{
                                  height: 0,
                                  amplitude: 4,
                                  speed: 0.5,
                                  points: 3,
                                }}></Wave>
                              <img
                                src={tankImage}
                                alt=''
                                className='position-absolute top-0 start-0'
                                style={{
                                  width: "290px",
                                  height: "320px",
                                  marginTop: "30px",
                                  marginLeft: "10px",
                                }}
                              />
                              <span
                                className='h1 position-absolute'
                                style={{
                                  marginTop: "-170px",
                                  marginLeft: "50px",
                                }}>
                                {deviceOnes.level && deviceOnes.ho
                                  ? parseInt(
                                      (deviceOnes.level / deviceOnes.ho) * 100
                                    ) + "%"
                                  : "0%"}
                              </span>
                            </Col>
                            <Col lg={6}>
                              <p className='mt-5'>Sensor Values :</p>
                              {(deviceOnes.device_parameter || []).map(
                                (params, paramsId) => {
                                  return (
                                    <div
                                      key={
                                        "param-" + deviceId + "-" + paramsId
                                      }>
                                      {params.showInDashboard &&
                                      params.statusId === 2 ? (
                                        <>
                                          <p>
                                            {`${params.label} : `}
                                            <span
                                              style={{
                                                color: "#007fbe",
                                              }}>
                                              {params.amount
                                                ? handleParams(params.amount)
                                                : "0"}
                                            </span>
                                          </p>
                                        </>
                                      ) : (
                                        ""
                                      )}
                                    </div>
                                  );
                                }
                              )}
                            </Col>
                          </Row>
                        </Col>
                        <Col
                          lg={6}
                          className='border border-2 '
                          style={{ height: "420px" }}>
                          <StatisticComponent
                            series={series}
                            seriesCategories={seriesCategories}
                            t={t}
                          />
                        </Col>
                      </Row>
                    </CardBody>
                  </Row>
                </div>
                <ToastContainer closeButton={false} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

ReportTemplate.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(ReportTemplate));
